/* eslint-disable no-shadow, no-param-reassign */
const axios = require("axios");
const swal = require("sweetalert2");

const state = () => ({
  addSubscriberErrors: [],
  addSubscriberSuccess: false,
  customerId: null,
  loading: false,
  products: null,
  selectedSubscriberId: null,
  subscribers: [],
  canExtend: false,
  canEnd: false,
  canCreate: false,
  canUpgrade: false,
  canReactivate: false,
  showWelcomeKit: false,
  error: null,
  subscriberTableLoading: true,
});

const getters = {
  getSubscribers: (state) => {
    return state.subscribers;
  },

  getCustomerId: (state) => {
    return state.customerId;
  },
};

const mutations = {
  SET_SUBSCRIBER_TABLE_LOADING(state, value) {
    state.subscriberTableLoading = value;
  },
  SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_SELECTED_SUBSCRIBER_ID(state, value) {
    state.selectedSubscriberId = value;
  },
  SET_PRODUCTS(state, value) {
    state.products = value;
  },
  CLEAR_ADD_SUBSCRIBER_ERRORS(state) {
    state.addSubscriberErrors = [];
  },
  SET_SUBSCRIBERS(state, value) {
    state.subscribers = value;
  },
  SET_CUSTOMER_ID(state, value) {
    state.customerId = value;
  },
  SET_ADD_SUBSCRIBER_SUCCESS(state, value) {
    state.addSubscriberSuccess = value;
  },
  SET_SUBSCRIBER_ERRORS(state, value) {
    state.addSubscriberErrors = value;
  },
  SET_CAN_EXTEND(state, value) {
    state.canExtend = value;
  },
  SET_CAN_END(state, value) {
    state.canEnd = value;
  },
  SET_CAN_CREATE(state, value) {
    state.canCreate = value;
  },
  SET_CAN_UPGRADE(state, value) {
    state.canUpgrade = value;
  },
  SET_SHOW_WELCOME_KIT(state, value) {
    state.showWelcomeKit = value;
  },
  SET_CAN_REACTIVATE(state, value) {
    state.canReactivate = value;
  },
  SET_ERROR(state, value) {
    state.error = value;
  },
};
const actions = {
  async removeFromCart({ commit }, subscriberId) {
    let response;
    try {
      response = await axios.post(
        `/account/testdrive/subscriber/${subscriberId}/remove`
      );
      if (response.status === 200) {
        commit("SET_SUBSCRIBERS", response.data.subscribers);
      }
      return response;
    } catch (error) {
      return response;
    }
  },
  async upgradeTestDrive({ commit, state }, itemId) {
    commit("SET_LOADING", true);
    const subscriberId = state.selectedSubscriberId;
    try {
      const response = await axios.post(
        `/account/testdrive/subscriber/${subscriberId}/upgrade`,
        { itemId }
      );
      if (response.status === 200 && !response.data.error) {
        commit("SET_LOADING", false);
        swal
          .fire({
            type: "success",
            title: "Success",
            html: "<h5>Congratulations! Your Test Drive has been upgraded! </h5><br/>",
            showCloseButton: true,
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: `Upgrade another Test Drive!`,
            confirmButtonText: `Take me to my Shopping Cart!`,
          })
          .then((result) => {
            commit("SET_SUBSCRIBERS", response.data.subscribers);
            if (result.value) {
              window.location.href = `/cart`;
            } else {
              swal.close();
              $("#upgrade_testdrive_modal").modal("hide");
            }
          });
      } else {
        commit("SET_LOADING", false);
        swal.fire({
          type: "error",
          title: "Oops...",
          html:
            "<h5>Something went wrong!</h5><br/>" +
            "<h5>Please refresh the page and try again.</h5><br/>",
          showConfirmButton: true,
        });
      }
    } catch (error) {
      commit("SET_LOADING", false);
      commit("SET_ERROR", error.message);
      swal.fire({
        title: "Uh oh..",
        type: "error",
        html: `<p style="font-size: small">We were unable to process your submission!</p>
            <p style="font-size: small">Please refresh your page and try again.</p>
          `,
      });
    }
  },
  async endTestDrive({ commit }, subscriberId) {
    let response;
    try {
      response = await axios.post(
        `/account/testdrive/subscriber/${subscriberId}/end`
      );
      if (response.status === 200) {
        commit("SET_SUBSCRIBERS", response.data.subscribers);
      }
      return response;
    } catch (error) {
      return response;
    }
  },
  async reactivateTestDrive({ commit }, subscriberId) {
    let response;
    try {
      response = await axios.post(
        `/account/testdrive/subscriber/${subscriberId}/reactivate`
      );
      if (response.status === 200) {
        commit("SET_SUBSCRIBERS", response.data.subscribers);
      }
      return response;
    } catch (error) {
      return response;
    }
  },
  async extendTestDrive({ commit }, subscriberId) {
    let response;
    try {
      response = await axios.post(
        `/account/testdrive/subscriber/${subscriberId}/extend`
      );
      if (response.status === 200) {
        commit("SET_SUBSCRIBERS", response.data.subscribers);
      }
      return response;
    } catch (error) {
      return response;
    }
  },
  getProducts({ commit, state }) {
    const { customerId } = state;
    axios
      .get(`/account/testdrive/${customerId}/products/`)
      .then((res) => {
        commit("SET_PRODUCTS", res.data.products);
      })
      .catch((error) => {
        commit("SET_ERROR", error.message);
        swal.fire({
          title: "Uh oh..",
          type: "error",
          html: `<p style="font-size: small">We were unable to complete your request!</p>
            <p style="font-size: small">Please refresh your page and try again.</p>
          `,
        });
      });
  },
  getSubscribers({ commit, getters }) {
    commit("SET_SUBSCRIBER_TABLE_LOADING", true);
    axios
      .get(`/account/testdrive/subscribers/${getters.getCustomerId}`)
      .then((res) => {
        commit("SET_SUBSCRIBERS", res.data.subscribers);
        commit("SET_CAN_EXTEND", res.data.canExtend);
        commit("SET_CAN_END", res.data.canEnd);
        commit("SET_CAN_UPGRADE", res.data.canUpgrade);
        commit("SET_CAN_CREATE", res.data.canCreate);
        commit("SET_SHOW_WELCOME_KIT", res.data.showWelcomeKit);
        commit("SET_CAN_REACTIVATE", res.data.canReactivate);
        commit("SET_SUBSCRIBER_TABLE_LOADING", false);
      })
      // eslint-disable-next-line no-unused-vars
      .catch((err) => {
        swal.fire({
          title: "Uh oh..",
          type: "error",
          html: `<p style="font-size: small">We were unable to complete your request!</p>
            <p style="font-size: small">Please refresh your page and try again.</p>
          `,
        });
      });
  },
  async addSubscriber({ commit, state }, field) {
    commit("CLEAR_ADD_SUBSCRIBER_ERRORS");
    commit("SET_LOADING", true);
    commit("SET_ADD_SUBSCRIBER_SUCCESS", false);
    const response = await axios
      .post(`/account/testdrive/subscribers/${state.customerId}`, field)
      .then((response) => {
        if (response.status === 200) {
          commit("SET_ADD_SUBSCRIBER_SUCCESS", true);
          commit("SET_SUBSCRIBERS", response.data.subscribers);
          commit("CLEAR_ADD_SUBSCRIBER_ERRORS");
          swal.fire({
            title: "Success!",
            type: "success",
            html: `<p style="font-size: small">New Test Drive subscriber added successfully!</p>`,
          });
        }
      })
      .catch(function (error) {
        const err = error.response.data.errors;
        // Array of error descriptions for use in current error display
        const errorValues = Object.entries(err).map((obj) => {
          return obj[1][0];
        });
        commit("SET_SUBSCRIBER_ERRORS", errorValues);
        swal.fire({
          title: "Uh oh..",
          type: "error",
          html: `<p style="font-size: small">We were unable to process your submission!</p>
            <p style="font-size: small">Please refresh your page and try again.</p>`,
        });
      });
    commit("SET_LOADING", false);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
